import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import { useEffect } from 'react';
import { useFirestore } from 'reactfire';
import { useToast } from '@/hooks/useToast';
import useTeamsWorkbooks from '@/features/Workbooks/hooks/useTeamsWorkbooks';
import { Loader } from '@/components/loaders/Modal';
import WorkbooksEmptyState from '@/components/tutorial/EmptyState';
import WorkbookCard from '@/components/workbook/WorkbookCard';
import parentStyles from '../styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const WorkbooksSelect = _ref => {
  let {
    teamId,
    workbookId,
    onSelect
  } = _ref;
  const firestore = useFirestore();
  const {
    addToast: sendNotification
  } = useToast();
  const {
    status,
    data,
    error
  } = useTeamsWorkbooks(firestore, teamId || 'na-team-id'); // show error notification if workbooks failed to load

  useEffect(() => {
    if (error) {
      sendNotification({
        description: 'There was an error loading your workbooks, please reload the page',
        type: 'error'
      });
    }
  }, [error, sendNotification]);
  const isLoaded = status === 'success';
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles.container, {
      [styles['container--empty']]: isLoaded && !data.length
    }),
    children: isLoaded && data.length ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("h4", {
        className: styles.title,
        children: "Team Workbooks"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.workbooks,
        children: data.map(workbook => {
          return /*#__PURE__*/_jsx(WorkbookCard, _objectSpread({
            elementId: workbook.id,
            isFeatured: workbook.id === workbookId,
            title: workbook.name || 'Unnamed',
            createdAt: workbook.createdAt,
            updatedAt: workbook.updatedAt,
            originFileType: workbook.originFileType // @ts-ignore
            ,
            syncConfig: workbook.syncConfig // @ts-ignore
            ,
            syncStatus: workbook.syncStatus // @ts-ignore
            ,
            warnings: workbook.warnings
          }, onSelect ? {
            onClick: () => onSelect(workbook)
          } : {}), workbook.id);
        })
      })]
    }) : isLoaded ? /*#__PURE__*/_jsx(WorkbooksEmptyState, {
      className: styles.emptyState,
      tutorial: {
        imgSrc: '/icons/file-table.svg',
        title: "You don't have any team workbooks"
      }
    }) : /*#__PURE__*/_jsx(Loader, {
      className: parentStyles.loader,
      title: ""
    })
  });
};

export default WorkbooksSelect;